var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningRound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.75,
    cx: 8,
    cy: 8,
    r: 5.5,
    stroke: "currentColor",
    strokeOpacity: 0.9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 4a1 1 0 011 1v3a1 1 0 11-2 0V5a1 1 0 011-1zm0 6a1 1 0 110 2 1 1 0 010-2z",
    fill: "currentColor",
    fillOpacity: 0.9
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2IiBmaWxsPSJub25lIj4KICA8Y2lyY2xlIG9wYWNpdHk9IjAuNzUiIGN4PSI4IiBjeT0iOCIgcj0iNS41IiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLW9wYWNpdHk9IjAuOSIvPgogIDxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNOCA0QzguNTUyMjggNCA5IDQuNDQ3NzIgOSA1TDkgOEM5IDguNTUyMjggOC41NTIyOSA5IDggOUM3LjQ0NzcyIDkgNyA4LjU1MjI4IDcgOEw3IDVDNyA0LjQ0NzcyIDcuNDQ3NzIgNCA4IDRaTTggMTBDOC41NTIyOSAxMCA5IDEwLjQ0NzcgOSAxMUM5IDExLjU1MjMgOC41NTIyOSAxMiA4IDEyQzcuNDQ3NzIgMTIgNyAxMS41NTIzIDcgMTFDNyAxMC40NDc3IDcuNDQ3NzIgMTAgOCAxMFoiIGZpbGw9ImN1cnJlbnRDb2xvciIgZmlsbC1vcGFjaXR5PSIwLjkiLz4KPC9zdmc+";
export { SvgWarningRound as ReactComponent };